import { render } from "./outbc2.vue?vue&type=template&id=d81ca458&scoped=true"
import script from "./outbc2.vue?vue&type=script&lang=js"
export * from "./outbc2.vue?vue&type=script&lang=js"

import "./outbc2.vue?vue&type=style&index=0&id=d81ca458&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81ca458"]])

export default __exports__